import { CheckPicker, Input, Loader, SelectPicker, Button } from "rsuite";
import "./index.scss";
import {
	useCrossellFilters,
	useCrossSellData,
	useCrossSellItemLevelData,
	// useCrossSellSKULevelData,
	useCrossSellTotalData,
	// updateSKUDataRecords,
	getCrossSellSKULevelData,
	updateCrossSellSKUData,
} from "../../react-query/hooks/HReports";
import { useEffect, useState } from "react";
import "../../scss/dropdown.scss";

import useResponsiveWidth from "../../react-query/hooks/useResponsiveWidth";
import CrossSellOpportunityDetails from "./crossSellOpportunityDetails";
import CrossSellRecommendations from "./crossSellRecommendations";
import { crossSellFilter } from "../../services/interfaces/ICrossSellOpportunity";
import { PriotiyValue } from "../../utils/constants";
import SyncIcon from "../../assets/sync-icon.svg";
import uparrowFilter from "../../assets/uparrowFilter.svg";
import downarrowFilter from "../../assets/downarrowFilter.svg";
import CustomLoader from "../../components/custom-loader";
import FrequentlyBoughtTable from "./frequentlyBoughtTable";
import SubstituteTable from "./substituteTable";
import MainHeader from "../../components/Layouts/MainHeader";
import FilterComponent from "../../components/common/FilterComponent";

const CrossSell = () => {
	const width = useResponsiveWidth();

	const [selectedL1, setSelectedL1] = useState<Array<string>>([]);
	const [selectedL2, setSelectedL2] = useState<Array<string>>([]);
	const [selectedL3, setSelectedL3] = useState<Array<string>>([]);
	const [selectedL4, setSelectedL4] = useState<Array<string>>([]);
	const [selectedPriority, setSelectedPriority] = useState<string | null>(
		null
	);

	const [selectedCustomer, setSelectedCustomer] = useState<string | null>(
		null
	);
	const [selectedPeerName, setSelectedPeerName] = useState<string | null>(
		null
	);
	const [selectedItemID, setSelectedItemID] = useState<string | null>(null);

	const [searchItemID, setSearchItemID] = useState<string | null>(null);
	const [searchCustomer, setSearchCustomer] = useState<string | null>(null);
	const [saveButton, setSaveButton] = useState<boolean>(false);
	const [frequentlyBoughtSaveButton, setFrequentlyBoughtSaveButton] =
		useState<boolean>(false);
	const [pageNumber, setPageNumber] = useState<number>(1);
	const [selectedCustomerId, setSelectedCustomerId] = useState<any>(null);
	const [selectedPeer, setSelectedPeer] = useState<any>(null);
	const [selectedItem, setSelectedItem] = useState<any>(null);
	const [saveStatus, setSaveStatus] = useState<boolean>(false);
	const [frequentsaveStatus, setFrequentSaveStatus] =
		useState<boolean>(false);
	const [filterExpansion, setfilterExpansion] = useState<boolean>(true);
	const [isLoadingSKUData, setIsLoadingSKUData] = useState<boolean>(false);

	const [updateSKUData, setUpdateSKUData] = useState<Array<any>>([]);
	const [updateFrequentSKUData, setUpdateFrequentSKUData] = useState<
		Array<any>
	>([]);
	const [categoryType, setCategoryType] = useState<string>("associated");
	const [refreshStatus, setRefreshStatus] = useState<boolean>(false);

	const [filters, setFilters] = useState<crossSellFilter>({
		l1: [],
		l2: [],
		l3: [],
		l4: [],
		itemid: null,
		customer: null,
		pageNumber: pageNumber,
		pageSize: 10,
	});
	const { crossellFilters, isLoading } = useCrossellFilters(
		filters?.l1,
		filters?.l2,
		filters?.l3,
		filters?.l4
	);

	const { crossellData, isLoadingReportData } = useCrossSellData(
		filters?.l1,
		filters?.l2,
		filters?.l3,
		filters?.l4,
		filters?.itemid,
		filters?.customer,
		pageNumber,
		filters?.pageSize,
		selectedPriority,
		refreshStatus
	);
	const { crossellTotalData } = useCrossSellTotalData(
		filters?.l1,
		filters?.l2,
		filters?.l3,
		filters?.l4,
		filters?.itemid,
		filters?.customer,
		refreshStatus,
		selectedPriority
	);

	const { crossellItemLevelData } = useCrossSellItemLevelData(
		filters?.l1,
		filters?.l2,
		filters?.l3,
		filters?.l4,
		filters?.itemid,
		selectedCustomer,
		selectedPeerName,
		refreshStatus,
		selectedPriority
	);


	const getCrossSellSKULevelDataHandler = async (itemId: any) => {
		setIsLoadingSKUData(true);
		let payload = {
			l1: filters?.l1,
			l2: filters?.l2,
			l3: filters?.l3,
			l4: filters?.l4,
			itemid: itemId,
			customer: selectedCustomer,
			peerGroupName: selectedPeerName,
			priority_group_flag: selectedPriority,
		};
		const res = await getCrossSellSKULevelData(payload);
		setCrossellSKULevelDataCopy(res?.data);
		setIsLoadingSKUData(false);
	};

	const updateCrossSellSKUDataHandler = async (data: any) => {
		let payload = {
			data: data,
			type: categoryType == "associated" ? "crosssell" : "frequent",
		};
		const res = await updateCrossSellSKUData(payload);
		setUpdateSKUData([]);
		setUpdateFrequentSKUData([]);
		setSaveButton(false);
		setFrequentlyBoughtSaveButton(false);
		getCrossSellSKULevelDataHandler(selectedItemID);
	};

	const [crossellSKULevelDataCopy, setCrossellSKULevelDataCopy] =
		useState<any>({});
	const [crossellItemLevelDataCopy, setCrossellItemLevelDataCopy] = useState<
		Array<any>
	>([]);
	const [crossellDataCopy, setCrossellDataCopy] = useState<Array<any>>([]);
	const [crossellTotalDataCopy, setCrossellTotalDataCopy] = useState<
		Array<any>
	>([]);

	useEffect(() => {
		if (selectedItemID) getCrossSellSKULevelDataHandler(selectedItemID);
	}, [selectedPriority]);

	useEffect(() => {
		setCrossellDataCopy(crossellData);
	}, [crossellData]);

	useEffect(() => {
		setCrossellItemLevelDataCopy(crossellItemLevelData);
	}, [crossellItemLevelData]);

	useEffect(() => {
		setCrossellTotalDataCopy(crossellTotalData);
	}, [crossellTotalData]);

	useEffect(() => {
		setSelectedItemID(null);
	}, [filters]);

	useEffect(() => {
		setSelectedCustomerId(null);
		setSelectedPeer(null);
		setSelectedItem(null);
	}, [selectedL4, selectedL3, selectedL2, selectedL1]);

	const handleUpdateSKUData = (data: any) => {
		let crossellTotalDataC = JSON.parse(
			JSON.stringify(crossellTotalDataCopy)
		);
		let crossellDataC = JSON.parse(JSON.stringify(crossellDataCopy));
		let crossellItemLevelDataC = JSON.parse(
			JSON.stringify(crossellItemLevelDataCopy)
		);
		let crossellSKULevelDataC = JSON.parse(
			JSON.stringify(crossellSKULevelDataCopy)
		);

		data?.forEach((val: any) => {
			if (!val?.marked) {
				let index = crossellDataC.findIndex(
					(e: any) =>
						`${e?.customer}_${e.peerGroupname}` ===
						`${selectedCustomerId}_${selectedPeerName}`
				);
				if (categoryType == "associated") {
					if (index !== -1) {
						crossellDataC[index].OpportunityMargin =
							val?.accept_ind === 0
								? crossellDataC[index]?.OpportunityMargin -
								val?.OpportunityMargin
								: crossellDataC[index].OpportunityMargin +
								val?.OpportunityMargin;
					}
					index = crossellItemLevelDataC.findIndex(
						(e: any) =>
							`${selectedCustomerId}_${e.l3}` ===
							`${selectedPeer}`
					);
					if (index !== -1) {
						crossellItemLevelDataC[index].OpportunityMargin =
							val?.accept_ind === 0
								? crossellItemLevelDataC[index]
									?.OpportunityMargin -
								val?.OpportunityMargin
								: crossellItemLevelDataC[index]
									?.OpportunityMargin +
								val?.OpportunityMargin;
					}

					let index1 = crossellItemLevelDataC[
						index
					]?.itemData.findIndex(
						(e: any) => `${e?.itemid}` === `${selectedItemID}`
					);
					if (index1 !== -1) {
						crossellItemLevelDataC[index].itemData[
							index1
						].itemLevelOpportunity =
							val?.accept_ind === 0
								? crossellItemLevelDataC[index].itemData[index1]
									?.itemLevelOpportunity -
								val?.OpportunityMargin
								: crossellItemLevelDataC[index].itemData[index1]
									?.itemLevelOpportunity +
								val?.OpportunityMargin;
					}
					crossellTotalDataC.OpportunityMargin =
						val?.accept_ind === 0
							? crossellTotalDataC?.OpportunityMargin -
							val?.OpportunityMargin
							: crossellTotalDataC?.OpportunityMargin +
							val?.OpportunityMargin;
					index = crossellSKULevelDataC.associated?.findIndex(
						(e: any) => `${e?.sku2}` === `${val?.sku2}`
					);
					if (index1 !== -1) {
						crossellSKULevelDataC.associated[index].accept_ind =
							val?.accept_ind;
					}
					console.log("crossellDataC", crossellSKULevelDataC);
				} else if (categoryType == "frequentlyBought") {
					console.log("crossellDataC**", crossellSKULevelDataC);

					index = crossellSKULevelDataC.frequency?.findIndex(
						(e: any) => `${e?.sku2}` === `${val?.sku2}`
					);
					// if (index1 !== -1) {
					crossellSKULevelDataC.frequency[index].acceptInd =
						val?.acceptInd;
					// }
				}
				setCrossellDataCopy(crossellDataC);
				setCrossellItemLevelDataCopy(crossellItemLevelDataC);
				setCrossellSKULevelDataCopy(crossellSKULevelDataC);
				setCrossellTotalDataCopy(crossellTotalDataC);
				val.marked = true;
			}
		});

		setUpdateSKUData(data);
	};

	const handleUpdatefrequentSKUData = (data: any) => {
		let crossellSKULevelDataC = JSON.parse(
			JSON.stringify(crossellSKULevelDataCopy)
		);

		data?.forEach((val: any) => {
			if (!val?.marked) {
				let index = 0;
				if (categoryType == "frequentlyBought") {
					index = crossellSKULevelDataC.frequency?.findIndex(
						(e: any) => `${e?.sku2}` === `${val?.sku2}`
					);
					// if (index1 !== -1) {
					crossellSKULevelDataC.frequency[index].acceptInd =
						val?.acceptInd;
					// }
				}
				setCrossellSKULevelDataCopy(crossellSKULevelDataC);
				val.marked = true;
			}
		});

		setUpdateFrequentSKUData(data);
	};

	return (
		<div className="reports-container flex flex-col justify-stretch items-stretch h-full volume-allocation">
			{(isLoading || isLoadingReportData) && (
				<div>
					<CustomLoader open={isLoading} />
				</div>
			)}
			<MainHeader headerName="Cross Sell" customClass="relative">
				{filterExpansion && (
					<div>
						<div className="w-full">
							<div className="flex justify-start items-center gap-[1vw] pb-[2vh]">
								<FilterComponent
									type="multi"
									filterName="L1"
									options={crossellFilters?.l1}
									labelKey="l1"
									valueKey="l1"
									loading={false}
									onFilterChange={(value: any) => {
										if (value) {
											setSelectedL1(value);
										}
									}}
									value={selectedL1}
									onClean={() => {
										setFilters({
											...filters,
											l1: [],
										});
									}}
									onClose={() => {
										setFilters({
											...filters,
											l1: selectedL1,
										});
									}}
								/>
								<FilterComponent
									type="multi"
									filterName="L2"
									options={crossellFilters?.l2}
									labelKey="l2"
									valueKey="l2"
									loading={false}
									onFilterChange={(value: any) => {
										if (value) {
											setSelectedL2(value);
										}
									}}
									value={selectedL2}
									onClean={() => {
										setFilters({
											...filters,
											l2: [],
										});
									}}
									onClose={() => {
										setFilters({
											...filters,
											l2: selectedL2,
										});
									}}
								/>
								<FilterComponent
									type="multi"
									filterName="L3"
									options={crossellFilters?.l3}
									labelKey="l3"
									valueKey="l3"
									loading={false}
									onFilterChange={(value: any) => {
										if (value) {
											setSelectedL3(value);
										}
									}}
									value={selectedL3}
									onClean={() => {
										setFilters({
											...filters,
											l3: [],
										});
									}}
									onClose={() => {
										setFilters({
											...filters,
											l3: selectedL3,
										});
									}}
								/>
								<FilterComponent
									type="multi"
									filterName="L4"
									options={crossellFilters?.l4}
									labelKey="l4"
									valueKey="l4"
									loading={false}
									onFilterChange={(value: any) => {
										if (value) {
											setSelectedL4(value);
										}
									}}
									value={selectedL4}
									onClean={() => {
										setFilters({
											...filters,
											l4: [],
										});
									}}
									onClose={() => {
										setFilters({
											...filters,
											l4: selectedL4,
										});
									}}
								/>
							</div>
						</div>
						<div className="flex justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer">
							<img
								className="w-[1.5vw]"
								src={uparrowFilter}
								alt="upArrow"
								onClick={() => {
									setfilterExpansion(false);
								}}
							/>
						</div>
					</div>
				)}
				{!filterExpansion && (
					<div
						className={`justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer`}
					>
						<img
							className="w-[1.5vw]"
							src={downarrowFilter}
							alt="upArrow"
							onClick={() => {
								setfilterExpansion(true);
							}}
						/>
					</div>
				)}
			</MainHeader>
			<div className="bg-[#F1F1F1] grow shrink p-[1.5%] pt-[.8%] below-1200:p-[1%] flex flex-col flex-nowrap justify-start items-start gap-[1vh] h-full w-full">
				<div className="flex min-h-[4vh] w-full gap-[1%]">
					<div className="flex gap-x-[3vh] justify-start w-[50%] text-[0.7vw]">
						<Input
							placeholder="Item"
							className="px-[1vh] w-[8vw] h-[5vh] text-black rounded-md text-[0.7vw]"
							onChange={(value: string) => {
								setSearchItemID(value);
							}}
						/>
						<Input
							placeholder="Customer"
							className="px-[1vh] w-[8vw] h-[5vh] text-black rounded-md text-[0.7vw]"
							onChange={(value: string) => {
								setSearchCustomer(value);
							}}
						/>
						<Button
							size="md"
							className="btn-text !bg-deloitteGreen w-[10vh] !text-white"
							onClick={() => {
								setFilters({
									...filters,
									itemid: searchItemID ? searchItemID : "",
									customer: searchCustomer
										? searchCustomer
										: "",
								});
								setSelectedCustomerId(null);
								setSelectedPeer(null);
								setSelectedItem(null);
							}}
						>
							Search
						</Button>
					</div>
					<div className="flex justify-between w-[50%] priority-filter ">
						<div
							className={`flex flex-col justify-start items-start min-w-[8vw] max-w-[8vw] mt-[0.8vh]`}
						>
							{/* <label className="font-medium text-fs16">L1</label> */}
							{categoryType == "associated" && (
								<SelectPicker
									data={PriotiyValue}
									value={selectedPriority}
									labelKey="label"
									valueKey="value"
									size="xs"
									className=""
									style={{ width: width }}
									onClean={() => {
										setSelectedPriority(null);
									}}
									onChange={(value: string | null) => {
										if (value) {
											setSelectedPriority(value);
										}
									}}
									searchable={false}
									placeholder="Priority"
									cleanable={true}
								></SelectPicker>
							)}
						</div>
						{selectedItemID && (
							<div className="flex w-full pl-[2vh] gap-x-[4vh] text-[.7vw]">
								<button
									className={` btn-text ml-2 w-[8vw] rounded-md ${categoryType == "associated"
										? "bg-[#86BC25] text-white"
										: "bg-[#bebebe] text-black"
										}
                ${crossellSKULevelDataCopy?.associated?.length > 0
											? ""
											: "cursor-not-allowed bg-[#dedede] text-[#00000082]"
										}
                `}
									onClick={() => {
										if (
											crossellSKULevelDataCopy?.associated
												?.length > 0
										) {
											setCategoryType("associated");
										}
									}}
								>
									Cross Sell
								</button>
								<button
									className={`ml-2 w-[8vw] btn-text rounded-md ${categoryType == "frequentlyBought"
										? "bg-[#86BC25] text-white"
										: "bg-[#bebebe] text-black"
										}
                ${crossellSKULevelDataCopy?.frequency?.length > 0
											? ""
											: "cursor-not-allowed bg-[#dedede] text-[#00000082]"
										}
                `}
									onClick={() => {
										if (
											crossellSKULevelDataCopy?.frequency
												?.length > 0
										) {
											setCategoryType("frequentlyBought");
										}
									}}
								>
									Frequently Bought
								</button>
								<button
									className={`ml-2 w-[8vw] btn-text rounded-md ${categoryType == "substitutes"
										? "bg-[#86BC25] text-white"
										: "bg-[#bebebe] text-black"
										}
                ${crossellSKULevelDataCopy?.sku?.length > 0
											? ""
											: " cursor-not-allowed bg-[#dedede] text-[#00000082]"
										}
                `}
									onClick={() => {
										if (
											crossellSKULevelDataCopy?.sku
												?.length > 0
										) {
											setCategoryType("substitutes");
										}
									}}
								>
									Substitutes
								</button>
							</div>
						)}
						{saveButton && categoryType == "associated" && (
							<Button
								size="md"
								className="text-white bg-[#86BC25] h-[5vh] btn-text px-[1vw] py-[0.5vh] focus:bg-[#86BC25] hover:bg-[#86BC25] disabled:bg-[#86BC25] disabled:opacity-[0.6] mr-[2vw]"
								onClick={() => {
									setSaveButton(false);
									setSaveStatus(true);
									updateCrossSellSKUDataHandler(
										updateSKUData
									);
								}}
							>
								Save
							</Button>
						)}
						{frequentlyBoughtSaveButton &&
							categoryType == "frequentlyBought" && (
								<Button
									size="md"
									className="text-white bg-[#86BC25] h-[5vh] btn-text px-[1vw] py-[0.5vh] focus:bg-[#86BC25] hover:bg-[#86BC25] disabled:bg-[#86BC25] disabled:opacity-[0.6] mr-[2vw]"
									onClick={() => {
										setFrequentlyBoughtSaveButton(false);
										setFrequentSaveStatus(true);
										updateCrossSellSKUDataHandler(
											updateFrequentSKUData
										);
									}}
								>
									Save
								</Button>
							)}
					</div>
				</div>
				<div className="flex  w-full gap-4">
					<div
						className={`pricing-container shadow-module-card rounded w-[50%] bg-white
              ${filterExpansion ? "h-[58vh]" : "h-[66vh]"}
            `}
					>
						<CrossSellOpportunityDetails
							onCustomerSelect={(data: any) => {
								setSelectedCustomer(data?.customer);
								setSelectedPeerName(data?.peerGroupname);
							}}
							crossellDataCopy={crossellDataCopy}
							crossellTotalData={crossellTotalDataCopy}
							crossellItemLevelDataCopy={
								crossellItemLevelDataCopy
							}
							onItemSelect={(val: any) => {
								setSelectedItemID(val);
								getCrossSellSKULevelDataHandler(val);
							}}
							pageNumber={pageNumber}
							updatePageNumber={(page: number) => {
								setPageNumber(page);
							}}
							selectedCustomerId={selectedCustomerId}
							selectedPeer={selectedPeer}
							selectedItem={selectedItem}
							updateSelectedCustomerId={(data: any) => {
								setSelectedCustomerId(data);
							}}
							updateSelectedPeer={(data: any) => {
								setSelectedPeer(data);
							}}
							updateSelectedItem={(data: any) => {
								setSelectedItem(data);
							}}
						/>
					</div>
					<div
						className={`shadow-module-card rounded w-[50%]  ${filterExpansion ? "h-[58vh]" : "h-[66vh]"
							} bg-white`}
					>
						{crossellSKULevelDataCopy?.associated?.length > 0 &&
							selectedItemID &&
							categoryType == "associated" ? (
							<CrossSellRecommendations
								isFilterExpanded={filterExpansion}
								updateSKULevelData={(data: any) => {
									handleUpdateSKUData(data);
								}}
								crossellSKULevelDataCopy={
									crossellSKULevelDataCopy?.associated
								}
								crossellData={crossellData}
								selectedItemID={selectedItemID}
								updateSaveButton={(status: boolean) => {
									setSaveButton(status);
								}}
								selectedCustomerId={selectedCustomerId}
								selectedPeerName={selectedPeerName}
								selectedItem={selectedItem}
								updateSKUData={updateSKUData}
							/>
						) : crossellSKULevelDataCopy?.frequency?.length > 0 &&
							selectedItemID &&
							categoryType == "frequentlyBought" ? (
							<FrequentlyBoughtTable
								updateSKULevelData={(data: any) => {
									handleUpdatefrequentSKUData(data);
								}}
								crossellSKULevelDataCopy={
									crossellSKULevelDataCopy?.frequency
								}
								crossellData={crossellData}
								selectedItemID={selectedItemID}
								updateSaveButton={(status: boolean) => {
									setFrequentlyBoughtSaveButton(status);
								}}
								selectedCustomerId={selectedCustomerId}
								selectedPeerName={selectedPeerName}
								selectedItem={selectedItem}
								updateSKUData={updateFrequentSKUData}
							/>
						) : crossellSKULevelDataCopy?.sku?.length > 0 &&
							selectedItemID &&
							categoryType == "substitutes" ? (
							<SubstituteTable
								crossellSKULevelDataCopy={
									crossellSKULevelDataCopy?.sku
								}
								crossellData={crossellData}
								selectedItemID={selectedItemID}
							/>
						) : (
							<div className="flex h-full justify-center items-center font-medium">
								{isLoadingSKUData ? (
									// <Loader content="Loading..." />
									<div>
										<CustomLoader open={isLoadingSKUData} />
									</div>
								) : (
									<span className="h-full flex justify-center items-center italic font-normal text-[2.5vh] text-center text-black">
										Please select Customer & Item to see
										Cross-sell Recommendations
									</span>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default CrossSell;
